module.exports = __webpack_public_path__ + "img/elaine.b1a78d97.png";